import { isNil } from 'ramda';
import {
  addMonths,
  endOfMonth,
  format,
  formatISO,
  isAfter,
  isBefore,
  isSameMonth,
  isValid,
  parseISO,
  startOfMonth,
  sub,
  subMonths,
} from 'date-fns';

export const defaultFormat = 'dd-MM-yyyy';
const formatDateToISO = date =>
  typeof date === 'string' ? parseISO(date) : date;

export const nextMonth = () => {
  return addMonths(new Date(), 1);
};

export const tzUTC = (date, time = null) => {
  // 17/05/2020, 23:59:59, 00:00:01
  const [dd, mm, yyyy] = date.split('/'); // 2019-11-20
  const currentTime = new Date().toLocaleTimeString();

  if (time) {
    return new Date(`${mm}/${dd}/${yyyy} ${time}`).toISOString();
  }

  return new Date(`${mm}/${dd}/${yyyy} ${currentTime}`).toISOString();
};

export const formatDate = (date, dateFormat = null) => {
  const formattedDate = formatDateToISO(date);

  return date ? format(formattedDate, dateFormat || defaultFormat) : '';
};

export const validateDate = date => {
  if (isNil(date) || date === '') {
    return false;
  }

  const [dd, mm, yyyy] = date.split('/'); // 2019-11-20

  return date.length < 10 ? false : isValid(new Date(`${yyyy}-${mm}-${dd}`));
};

export const startOfDay = date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

export const getEarlierDate = (dateOne, dateTwo) => {
  return isAfter(parseISO(dateOne), parseISO(dateTwo)) ? dateTwo : dateOne;
};

export const buildDateRange = start => {
  let current = parseISO(start);
  const list = [];

  while (isBefore(current, new Date()) || isSameMonth(current, new Date())) {
    list.push(formatDate(current, 'MM-yyyy'));
    current = addMonths(current, 1);
  }

  return list;
};

export const isBeforeDate = (dateOne, dateTwo) => {
  const formattedDateOne = formatDateToISO(dateOne);
  const formattedDateTwo = formatDateToISO(dateTwo);

  return isBefore(formattedDateOne, formattedDateTwo);
};

export const computeDateRangeDates = (dates, isMonth = false) => {
  if (Array.isArray(dates) && dates[0] && dates[1]) {
    const [startDate, endDate] = dates;

    if (isMonth) {
      return {
        start_date: startOfMonth(startDate).toISOString(),
        end_date: endOfMonth(endDate).toISOString(),
      };
    }

    return {
      start_date: startOfDay(startDate).toISOString(),
      end_date: endOfDay(endDate).toISOString(),
    };
  }

  return {};
};

export const getTimezoneOffset = () => {
  const date = new Date();

  return date.getTimezoneOffset();
};

export const endOfDay = date =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999,
  );

export const isAfterToday = date => isAfter(date, new Date());
export const subDurationFromToday = duration => sub(new Date(), duration);
export const subMonthsFromDate = (date, months) =>
  subMonths(parseISO(date), months);
